import { render, staticRenderFns } from "./CrmSpaStaleUpdateRoot.vue?vue&type=template&id=1817355c&"
import script from "./CrmSpaStaleUpdateRoot.vue?vue&type=script&lang=ts&"
export * from "./CrmSpaStaleUpdateRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports